import {
    CART_CLEAN,
    ADDRESS_OPTIONS_CREATE,
    ADDRESS_OPTIONS_REMOVE,
    ADDRESS_OPTIONS_CLEAN,
    ADDRESS_AVAILABLE_OPTIONS_SET,
    ADDRESS_OPTIONS_TRACKING
} from '../actions/actionTypes';

import _uniq from 'lodash/uniq';

const defaultState = {
    byId: [],
    byHash: {},
    availableOptions: [],
    trackingPhone: {
        code: "",
        number: ""
    }
};

export default (state = defaultState, action = {}) => {
    switch (action.type) {
        case ADDRESS_OPTIONS_CREATE: {
            return {
                ...state,
                byId: _uniq([...state.byId, action.payload.seller_id]),
                byHash: {
                    ...state.byHash,
                    [action.payload.seller_id]: action.payload
                }
            };
        }
        //case ADDRESS_OPTIONS_UPDATE: {
        //    state.byHash[action.id] = {
        //        ...state.byHash[action.id],
        //        ...action.payload
        //    };
        //    return {
        //        ...state
        //    }
        //}
        case ADDRESS_OPTIONS_REMOVE: {
            const prunedIds = state.byId.filter(item => {
                return item !== action.id // return all the items not matching the action.id
            });
            delete state.byHash[action.id]; // delete the hash associated with the action.id

            return {
                ...state,
                byId: prunedIds,
                byHash: state.byHash
            }
        }
        case ADDRESS_AVAILABLE_OPTIONS_SET: {
            return {
                ...state,
                availableOptions: {...action.payload}
            };
        }
        case ADDRESS_OPTIONS_TRACKING: {
            return { ...state, trackingPhone: {...state.trackingPhone, [action.key]: action.value }};
        }
        case CART_CLEAN:
        case ADDRESS_OPTIONS_CLEAN:
            {
            return {
                ...state,
                byId: [],
                byHash: {}
            }
        }

        default:
            return state;
    }
};